interface SplashScreenProps {
  visible: boolean;
}

export function SplashScreen({ visible }: SplashScreenProps) {
  return (
    <div
      className="fixed inset-0 z-[3000] flex flex-col items-center justify-center bg-white transition-opacity duration-500"
      style={{ opacity: visible ? 1 : 0, pointerEvents: visible ? 'auto' : 'none' }}
    >
      <img src="/favicon.svg" alt="RideHub" className="w-48 h-48" />
    </div>
  );
}
